// extracted by mini-css-extract-plugin
export var logo = "_m6-2";
export var logoWrapper = "_m6-1";
export var strip = "_m6-0";